import { getEditor } from 'agentable-canvas/whiteboard';
import { putSiteCanvasState } from './site-media-api';

export interface SaveCanvasSnapshotResult {
  ok: boolean;
  error?: string;
}

/** Immediately persist the current tldraw snapshot for a site (no debounce). */
export async function saveCanvasSnapshotNow(siteId: string): Promise<SaveCanvasSnapshotResult> {
  const editor = getEditor();
  if (!editor) {
    return { ok: false, error: 'Canvas editor is not ready' };
  }

  try {
    const snapshot = editor.getSnapshot();
    await putSiteCanvasState(siteId, {
      snapshot,
      updatedAt: new Date().toISOString(),
    });
    return { ok: true };
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : 'Canvas snapshot save failed';
    console.error('[saveCanvasSnapshotNow]', message, err);
    return { ok: false, error: message };
  }
}
